
















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { IGameItemForSaleByGala } from '~/store/games/types';
import _kebabCase from 'lodash.kebabcase';
import StoreItemCard from '~/components/Store/StoreItemCard.vue';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

@Component({ components: { StoreItemCard } })
export default class ItemListCarousel extends Vue {
  @Prop(Array) readonly data!: IGameItemForSaleByGala[];
  @Prop(Function) readonly viewAll!: () => void;

  @Prop(String) readonly listTitle!: string;
  @Prop({ type: String, default: 'View More' }) headerLinkText!: string;

  get swiperBreakpoints() {
    return {
      600: {
        slidesPerView: 3,
        slidesPerGroup: 2,
      },
      1100: {
        slidesPerView: 4,
        slidesPerGroup: 3,
      },
      1450: {
        slidesPerView: 5,
        slidesPerGroup: 4,
      },
      1650: {
        slidesPerView: 6,
        slidesPerGroup: 4,
      },
    };
  }

  get itemsForSale() {
    return this.data;
  }

  get itemListLength() {
    return this.itemsForSale.length;
  }

  get listId() {
    return _kebabCase(this.listTitle);
  }

  mounted() {
    const el = this.$refs?.[
      `swiperItemListContainer${this.listId}`
    ] as HTMLElement;
    if (!el) {
      return;
    }

    new Swiper(el, {
      slidesPerView: 2,
      slidesPerGroup: 2,
      modules: [Navigation],
      speed: 300,
      spaceBetween: 8,
      resistance: false,
      navigation: {
        nextEl: `.item-list-carousel-button-next-${this.listId}`,
        prevEl: `.item-list-carousel-button-prev-${this.listId}`,
      },
      breakpoints: this.swiperBreakpoints,
    });
  }

  goToItem(item: any) {
    this.$router.push(`/games/buy-item/${item.baseId}`);
  }
}
